import { getCurrentLang } from "@/utils/Local";

import type { AxiosInstance } from "axios";

export default function initInterceptors(httpService: AxiosInstance): void {
  httpService.interceptors.request.use((request) => {
    request.headers.Language = getCurrentLang();
    return request;
  });

  httpService.interceptors.response.use(
    (res) => res,
    async (error) => Promise.reject(error),
  );
}
